<template>
  <c-row>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Informasi Transaksi Penjualan</strong>
            <div class="card-header-actions">
              <date-range @select="changeDate" />
            </div>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Tanggal</th>
                  <th>Invoice</th>
                  <th>Customer</th>
                  <th>Type</th>
                  <th>Alamat</th>
                  <th>No. Telepon</th>
                  <th>Petugas</th>
                  <th>Via</th>
                  <th>Kode Item & Garansi</th>
                  <th>Nama</th>
                  <th>Qty</th>
                  <th>HPP</th>
                  <th>Jual</th>
                  <th>Laba</th>
                  <th>Sub Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="report.data && report.data.length <= 0">
                  <td colspan="12" class="center">
                    Data tidak ditemukan untuk range tanggal
                    <strong>{{ this.dateRange.startDate.format("DD-MMM-YYYY") }} sd.
                      {{ this.dateRange.endDate.format("DD-MMM-YYYY") }}</strong>
                  </td>
                </tr>
              </tbody>
              <tbody v-for="(v, k) in report.data" :key="k">
                <tr>
                  <td :rowspan="v.details.length + 1">
                    <table-number :index="k" :paginate="report.paginate" />
                  </td>
                  <td :rowspan="v.details.length + 1" style="width: 100px">
                    {{ v.created_at | dateTimeFormat }}
                  </td>
                  <td :rowspan="v.details.length + 1" style="width: 120px">
                    {{ v.invoice }}
                  </td>
                  <td :rowspan="v.details.length + 1" style="width: 220px">
                    {{ v.customer_name }}
                  </td>
                  <td :rowspan="v.details.length + 1" style="width: 220px">
                    <label v-show="v.customer_type_id == 2">Dealer 1</label>
                    <label v-show="v.customer_type_id == 3">Dealer 2</label>
                    <label v-show="v.customer_type_id == 4">Dealer 3</label>
                    <label v-show="v.customer_type_id == 1">Retail</label>
                  </td>
                  <td :rowspan="v.details.length + 1" style="width: 220px">
                    {{ v.customer_address }}
                  </td>
                  <td :rowspan="v.details.length + 1" style="width: 220px">
                    {{ v.customer_phone }}
                  </td>
                  <td :rowspan="v.details.length + 1" style="width: 70px">
                    {{ v.user_name }}
                  </td>
                  <td :rowspan="v.details.length + 1" style="width: 70px">
                    {{ v.channel_name }}
                  </td>
                  <td>{{ v.details[0].warranty_code }}</td>
                  <td>{{ v.details[0].item_name }}</td>
                  <td>{{ v.details[0].qty }}</td>
                  <td class="right">
                    {{ v.details[0].hpp | thousandSeparator }}
                  </td>
                  <td class="right">
                    {{ v.details[0].price | thousandSeparator }}
                  </td>
                  <td class="right">
                    {{ v.details[0].laba | thousandSeparator }}
                  </td>
                  <td class="right">
                    {{ v.details[0].sub_total | thousandSeparator }}
                  </td>
                </tr>
                <tr v-for="(vd, kd) in v.details" :key="kd" v-show="kd >= 1">
                  <td>{{ vd.warranty_code }}</td>
                  <td>{{ vd.item_name }}</td>
                  <td>{{ vd.qty }}</td>
                  <td class="right">{{ vd.hpp | thousandSeparator }}</td>
                  <td class="right">{{ vd.price | thousandSeparator }}</td>
                  <td class="right">{{ vd.laba | thousandSeparator }}</td>
                  <td class="right">{{ vd.sub_total | thousandSeparator }}</td>
                </tr>
                <tr>
                  <td colspan="6" class="tb-total">Total Transaksi</td>
                  <td class="tb-total">{{ v.total | thousandSeparator }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-success" @click="exportExcel">
            <i class="cil-cloud-download"></i> Excel
          </button>
          <paginator :paginator="report.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH, HTTPExport } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber2";
import DateRange from "../../components/DateRange";
import Paginator from '../../components/Paginator.vue';

export default {
  data () {
    return {
      report: {},
      currentPage: 1,
      total: 0,
      perPage: 10,
      startMonth: moment(moment().format("YYYY-MM-") + "01"),
      dateRange: {},
    };
  },
  components: {
    TableNumber,
    DateRange,
    Paginator,
  },
  created () {
    this.dateRange = {
      startDate: this.startMonth,
      endDate: moment(),
    };
    this.getList(1, "");
  },
  methods: {
    changePage (page) {
      let q = '';
      const query = this.$route.query
      if (query && query.q) {
        q = query.q
      }
      this.getList(page, q)
    },
    genDateRange () {
      var dateRange = "";
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
        dateRange = `&start_date=${startDate}&end_date=${endDate}`;
      }
      return dateRange;
    },
    getList (page, q) {
      var dateRange = "";
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
        dateRange = `&start_date=${startDate}&end_date=${endDate}`;
      }
      HTTPAUTH.get(
        `/api/v1/report-transaction/sale?page=${page}&size=${this.perPage}&q=${q}${dateRange}`
      ).then((res) => {
        this.report = res.data;
        this.currentPage = page;
        this.total = this.report.paginate.total;
        this.$router.push({
          query: { q: q, page: page, start: startDate, end: endDate },
        });
      });
    },
    changeDate (v) {
      this.dateRange = {
        startDate: moment(v.startDate),
        endDate: moment(v.endDate),
      };
      this.getList(1, "");
    },
    exportExcel () {
      const dateRange = this.genDateRange();
      HTTPExport.post(`/api/v1/report-transaction/excel/sale?q=${dateRange}`).then(res => {
        const data = res.data.data;
        window.open(data, '_blank');
      })
    }
  },
  watch: {
    currentPage (pageNext) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.getList(pageNext, q);
    },
  },
};
</script>